var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.effects)?_c('div',{staticClass:"m-equip-effect"},_vm._l((_vm.effects),function(effect,index){return _c('div',{key:index,staticClass:"u-equip-effect",class:'isFont-' + effect.font},[_vm._v(" "+_vm._s(effect.text)+" ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }